import request from './.request'
/**
 * 投入品管理
 */


/**
 * 多条件过滤查询投入品
 * @param {object} filter
 * @returns
 */
export function getInputs(filter) {
  return request({
    url: '/inputs',
    method: 'get',
    params: filter
  })
}
/**
 *
 * @param {number} enterpriseId
 */
export function getInputsByEnterpriseId(enterpriseId,params) {
  return request({
    url: `/inputs/${enterpriseId}?about=enterprise`,
    method: 'get',
    params: params
  })
}
/**
 * 新增投入品
 * @param {object} data 新投入品参数集合，参见接口文档
 * @returns
 */
export function addInputs(data) {
  return request({
    url: `/inputs`,
    method: 'post',
    data: data
  })
}

/**
 * 更新投入品到公司
 * @param {object} data 投入品数组
 * @returns
 */
export function updateInputs(data) {
  return request({
    url: '/inputs',
    method: 'put',
    data: data
  })
}
/**
 * 编辑投入品
 * @param {number} id 投入品id
 * @param {object} data 投入品新的参数，参见接口文档
 * @returns
 */
export function updateInputsById(id,data) {
  return request({
    url: `/inputs/${id}`,
    method: 'put',
    data: data
  })
}

/**
 * 删除投入品
 * @param {number} id 投入品id
 * @returns
 */
export function deleteInputs(data) {
  return request({
    url: '/inputs',
    method: 'delete',
    data:data
  })
}

/**
 * 根据id查询一个投入品的详细
 * @param {number} id 投入品id
 * @returns
 */
export function getInputsById(id) {
  return request({
    url: `/inputs/${id}`,
    method: 'get',
  })
}

/**
 * 按照关键字查询现有投入品的品牌列表，用于帮助快速输入
 * @param {string} keyword 品牌名称关键字
 * @returns
 */
export function getInputsBrands(keyword) {
  return request({
    url: `/inputs?keyword=${keyword}&about=brand`,
    method: 'get',
  })
}

/**
 * 按照关键字查询现有投入品的厂家名称列表，用于帮助快速输入
 * @param {string} keyword
 * @returns
 */
export function getInputsManufacturers(keyword) {
  return request({
    url: `/inputs?keyword=${keyword}&about=manufacturer`,
    method: 'get',
  })
}





// WEBPACK FOOTER //
// ./src/api/inputs.js